import { render, staticRenderFns } from "./LikertModification.vue?vue&type=template&id=00b80f10&scoped=true&"
import script from "./LikertModification.vue?vue&type=script&lang=js&"
export * from "./LikertModification.vue?vue&type=script&lang=js&"
import style0 from "./LikertModification.vue?vue&type=style&index=0&id=00b80f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b80f10",
  null
  
)

export default component.exports